module.exports = __webpack_public_path__ + "img/6.949e9c07.png";